module.exports = __webpack_public_path__ + "assets/img/btn-download-pc-64db15ef.png";